export const environment = {
  msalConfig: {
    auth: {
      clientId: '#{MSAL_CLIENT_ID}#',
      authority: '#{MSAL_AUTHORITY}#',
    },
  },
  apiConfig: {
    scopes: ['#{SCOPE}#'],
    uri: '#{GRAPH_API_URI}#',
  },
  adirApiConfig: {
    uri: '#{ADIR_API_URI}#',
  },
  fdpApiConfig: {
    uri: '#{FDP_API_URI}#',
  },
  userManagementApiConfig: {
    uri: '#{USER_MANAGEMENT_API_URI}#',
  }
};
